/** A change is "real" only when `nextId` is set and differs from the committed id. */
export function isRealTherapistChange(
	committedId: string | null | undefined,
	nextId: string | null | undefined,
): boolean {
	return !!nextId && committedId !== nextId;
}

/**
 * Whether choosing `nextId` on a visit must first confirm resetting later
 * visits: only on a real therapist change AND when later visits are scheduled.
 */
export function shouldConfirmLaterReset(args: {
	committedId: string | null | undefined;
	nextId: string | null | undefined;
	hasLaterVisits: boolean;
}): boolean {
	return (
		args.hasLaterVisits && isRealTherapistChange(args.committedId, args.nextId)
	);
}
